export const BUSINESS_BILL_PAY_PAYMENT_DETAIL_CONTAINER_TAG_NAME =
    'business-bill-pay-payment-detail-container';
